import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { me, meBusinesses } from '../initial_state'
import PageTitle from '../features/ui/util/page_title'
import BusinessLayout from '../layouts/business_layout'
import { openModal } from '../actions/modal'
import {
  MODAL_MARKETPLACE_LISTING_FILTER,
  BREAKPOINT_EXTRA_SMALL,
  MODAL_UNAUTHORIZED,
  SHORTCUT_TYPE_BUSINESS,
  MODAL_PRO_UPGRADE,
} from '../constants'
import SidebarPanelGroup from '../components/sidebar_panel_group'
// import BusinessFilterPanel from '../components/panel/business_filter_panel'
import TabBar from '../components/tab_bar'
import BusinessCategoriesScrollablePills from '../components/business/business_categories_scrollable_pills'
import Button from '../components/button'
import Text from '../components/text'
import List from '../components/list'
import ShortcutsPanel from '../components/panel/shortcuts_panel'

class BusinessPage extends React.PureComponent {

  handleOnOpenFilterModal = () => {
    const { isXS } = this.props
    this.props.dispatch(openModal(MODAL_MARKETPLACE_LISTING_FILTER, { isXS }))
  }

  handleOnOpenModal = () => {
    this.props.dispatch(openModal(MODAL_UNAUTHORIZED)) 
  }
  
  handleOnOpenProModal = () => {
    this.props.dispatch(openModal(MODAL_PRO_UPGRADE, { isBusiness: true }))
  }

  render() {
    const { children, isXS, page } = this.props
    
    const isMainPage = page === 'business'

    const xsTabs = !isXS ? undefined : [
      {
        title: 'Businesses',
        to: '/businesses',
        active: isMainPage,
      },
      {
        title: 'Categories',
        to: '/businesses/categories',
      },
      !!me && !!meBusinesses && {
        title: 'My Businesses',
        to: '/businesses/dashboard',
      },
    ].filter(Boolean)

    const actions = isXS ? [
      {
        attrTitle: 'Create new listing',
        icon: 'add',
        to: '/business/create',
      },
      {
        attrTitle: 'Sort and Filter',
        icon: 'search',
        onClick: this.handleOnOpenFilterModal
      }
    ] : undefined

    const tabs = [
      {
        title: 'Home',
        to: '/businesses',
        icon: 'home',
        hideArrow: true,
        shouldHighlight: true,
        isActive: isMainPage && !!me,
      },
      {
        title: 'Categories',
        icon: 'ul-list',
        to: '/businesses/categories',
      },
      !!me && !!meBusinesses && {
        title: 'My Businesses',
        to: '/businesses/dashboard',
        icon: 'apps',
      },
    ].filter(Boolean)

    const sidebarLayout = [
      <div key='bspcd-1' className={[_s.d, _s.w100PC, _s.boxShadowNone, _s.boxShadowNoneBg].join(' ')}>
        <List items={tabs} size='large' padded />
      </div>,
      (<div key='bspcd-3' className={[_s.d, _s.w100PC, _s.px5, _s.mb10, _s.pt10].join(' ')}>
        <Button
          isBlock
          radiusSmall
          to='/marketplace/business/join'
        >
          <Text color='inherit' weight='medium' size='medium' align='center'>List your Business →</Text>
        </Button>
      </div>),
      (<div key='mlcpcd-3' className={[_s.d, _s.w100PC, _s.px5, _s.pt5].join(' ')}>
        <Button
          isBlock
          isOutline
          radiusSmall
          backgroundColor='none'
          color='brand'
          onClick={this.handleOnOpenProModal}
        >
          <Text color='inherit' weight='medium' size='medium' align='center'>Get GabPRO for Business</Text>
        </Button>
      </div>),
      <ShortcutsPanel key='bspcd-5' type={SHORTCUT_TYPE_BUSINESS} noPanel />,
      // <BusinessFilterPanel key='bspcd-6' noPanel />,
    ]

    return (
      <BusinessLayout
        page='businesses'
        title='Businesses'
        actions={actions}
        noSidebar
        sidebarChildren={<SidebarPanelGroup layout={sidebarLayout} />}
        search={{
          placeholder: 'Search businesses',
          to: '/search/businesses',
        }}
        noRightSidebar
      >
        <PageTitle path='Businesses' />

        {
          isXS &&
          <div className={[_s.d, _s.w100PC, _s.h40PX, _s.z6, _s.top0, _s.right0, _s.left0, _s.posSticky, _s.bgPrimary, _s.borderBottom1PX, _s.borderColorSecondary].join(' ')}>
            <TabBar tabs={xsTabs} shouldGrow />
          </div>
        }

        {
          isXS && isMainPage && 
          <div className={[_s.d, _s.w100PC, _s.flexWrap, _s.pt15, _s.pb5, _s.px5, _s.flexRow, _s.borderBottom1PX, _s.borderColorSecondary].join(' ')}>
            <Button
              isNarrow
              radiusSmall
              className={[_s.flexGrow1, _s.mb10, _s.mr5, _s.ml5].join(' ')}
              to='/marketplace/business/join'
            >
              <Text color='inherit' align='center' weight='medium'>List your Business →</Text>
            </Button>
            <Button
              isNarrow
              radiusSmall
              className={[_s.flexGrow1, _s.mb10, _s.mr5, _s.ml5].join(' ')}
              to='/business/create'
            >
              <Text color='inherit' align='center' weight='medium'>Sell or List Item</Text>
            </Button>
          </div>
        }

        {
          isXS && isMainPage &&
          <div className={[_s.d, _s.mt15].join(' ')}>
            <BusinessCategoriesScrollablePills />
          </div>
        }
        
        {children}
      </BusinessLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

BusinessPage.propTypes = {
  children: PropTypes.node.isRequired,
  isXS: PropTypes.bool.isRequired,
}

export default connect(mapStateToProps)(BusinessPage)